import { render, staticRenderFns } from "./foreignDebt.vue?vue&type=template&id=75c4dad1&scoped=true&"
import script from "./foreignDebt.vue?vue&type=script&lang=js&"
export * from "./foreignDebt.vue?vue&type=script&lang=js&"
import style0 from "./foreignDebt.vue?vue&type=style&index=0&id=75c4dad1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c4dad1",
  null
  
)

export default component.exports